module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: 'field focus' + (_vm.nonEmptyPasswords && _vm.weak ? ' error' : ''),
    staticStyle: {
      "position": "relative"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.passwordLabel))]), _vm._v(" "), ((_vm.showPassword ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password1),
      expression: "password1"
    }],
    staticStyle: {
      "padding-right": "2.5rem"
    },
    attrs: {
      "id": "password1",
      "type": "password",
      "placeholder": "Password",
      "required": "true",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password1) ? _vm._i(_vm.password1, null) > -1 : (_vm.password1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.password1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password1 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password1 = $$c
        }
      }
    }
  }) : ((_vm.showPassword ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password1),
      expression: "password1"
    }],
    staticStyle: {
      "padding-right": "2.5rem"
    },
    attrs: {
      "id": "password1",
      "type": "password",
      "placeholder": "Password",
      "required": "true",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password1, null)
    },
    on: {
      "change": function($event) {
        _vm.password1 = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password1),
      expression: "password1"
    }],
    staticStyle: {
      "padding-right": "2.5rem"
    },
    attrs: {
      "id": "password1",
      "type": "password",
      "placeholder": "Password",
      "required": "true",
      "type": _vm.showPassword ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.password1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "position": "absolute",
      "right": "0.5rem",
      "top": "50%",
      "transform": "translateY(-50%)",
      "cursor": "pointer",
      "display": "flex",
      "align-items": "center",
      "height": "100%"
    },
    on: {
      "click": _vm.togglePasswordVisibility
    }
  }, [_c('i', {
    class: _vm.showPassword ? 'eye slash icon' : 'eye icon',
    staticStyle: {
      "font-size": "small",
      "padding": "2px",
      "margin-top": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field",
    staticStyle: {
      "position": "relative"
    }
  }, [((_vm.showPassword2 ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    staticStyle: {
      "padding-right": "2.5rem"
    },
    attrs: {
      "id": "password2",
      "placeholder": "Confirm password",
      "required": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password2) ? _vm._i(_vm.password2, null) > -1 : (_vm.password2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.password2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password2 = $$c
        }
      }
    }
  }) : ((_vm.showPassword2 ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    staticStyle: {
      "padding-right": "2.5rem"
    },
    attrs: {
      "id": "password2",
      "placeholder": "Confirm password",
      "required": "",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password2, null)
    },
    on: {
      "change": function($event) {
        _vm.password2 = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    staticStyle: {
      "padding-right": "2.5rem"
    },
    attrs: {
      "id": "password2",
      "placeholder": "Confirm password",
      "required": "",
      "type": _vm.showPassword2 ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "position": "absolute",
      "right": "0.5rem",
      "top": "50%",
      "transform": "translateY(-50%)",
      "cursor": "pointer",
      "display": "flex",
      "align-items": "center",
      "height": "100%"
    },
    on: {
      "click": _vm.togglePasswordVisibility2
    }
  }, [_c('i', {
    class: _vm.showPassword2 ? 'eye slash icon' : 'eye icon',
    staticStyle: {
      "font-size": "small"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0510c92c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PasswordInputPair.vue
// module id = 717
// module chunks = 2